/**
 * @file Input
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { useRefCallback, useCombineRef } from '@tencent/glue-react-use';
import { useStyleTransform } from '../hooks/useStyleTransform';
var isNotUndefined = function (val) { return typeof val !== 'undefined'; };
export var Input = forwardRef(function (props, originalRef) {
    var id = props.id, _a = props.className, elemClassName = _a === void 0 ? '' : _a, _b = props.style, elemStyle = _b === void 0 ? {} : _b, placeholder = props.placeholder, _c = props.type, type = _c === void 0 ? 'text' : _c, outterValue = props.value, defaultValue = props.defaultValue, autoFocus = props.autoFocus, disabled = props.disabled, maxLength = props.maxLength, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onClick = props.onClick, pattern = props.pattern;
    var _d = useStyleTransform(elemStyle, 'xj-h5-input', elemClassName), className = _d.className, ref = _d.ref, config = __rest(_d, ["className", "ref"]);
    var inputRef = useRef();
    var combinedRef = useCombineRef(ref, inputRef);
    var _e = useState(outterValue || defaultValue || ''), innerValue = _e[0], setInnerValue = _e[1];
    // 是否为受控组件
    var controlled = isNotUndefined(outterValue);
    var inputValue = controlled ? outterValue : innerValue;
    var onInput = useRefCallback(function (e) {
        var value = e.target.value;
        if (controlled === false) {
            setInnerValue(value);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    });
    useImperativeHandle(originalRef, function () { return ({
        focus: function () {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
        blur: function () {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        },
        clear: function () {
            if (controlled === false) {
                setInnerValue('');
            }
            onChange === null || onChange === void 0 ? void 0 : onChange('');
        },
        getValue: function () { var _a; return Promise.resolve(((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || ''); },
        setValue: function (value) {
            if (controlled === false) {
                setInnerValue(value);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        },
    }); });
    return (React.createElement("input", __assign({ id: id }, config, { ref: combinedRef, className: "xj-h5-input ".concat(className), value: inputValue, defaultValue: defaultValue, placeholder: placeholder, type: type, disabled: disabled, autoFocus: autoFocus, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onInput: onInput, pattern: pattern, maxLength: maxLength })));
});
